module.exports = __webpack_public_path__ + "static/media/slack.e7cb1abd.svg";